import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-back-to-list',
  standalone: true,
  templateUrl: './back-to-list.component.html',
  imports: [RouterLink, TranslateModule],
})
export class BackToListComponent {
  @Input({ required: true }) routerLink: string;
}
